'use client';

import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'accent' | 'global-bg-5-text' | 'global-bg-6-text';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'md', 
  disabled = false,
  type = 'button',
  className = '',
  style = {},
  ...props
}) => {
  const variants = {
    primary: 'bg-global-1 text-header-1 hover:opacity-90',
    secondary: 'bg-global-10 text-global-1 hover:opacity-90',
    accent: 'bg-global-9 text-global-1 hover:opacity-90',
    'global-bg-5-text': 'bg-global-1 hover:opacity-90',
    'global-bg-6-text': 'bg-global-1 hover:opacity-90'
  };

  const sizes = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2',
    lg: 'px-5 py-3 text-lg'
  };

  return (
    <button data-component-id="src/components/ui/Button.tsx:42:4" data-component-path="src/components/ui/Button.tsx" data-component-line="42" data-component-file="Button.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      type={type}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        ...(variant === 'global-bg-5-text'
          ? { color: 'var(--global-bg-5)' }
          : variant === 'global-bg-6-text'
          ? { color: 'var(--global-bg-6)' }
          : {}),
        ...style,
      }}
      className={`
        rounded 
        transition-colors 
        duration-150 
        focus:outline-none 
        font-tt-norms-bold
        ${variants[variant]} 
        ${sizes[size]} 
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} 
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;